<template>
  <div>
    <a-cascader class="title_text_input_class" :options="options" :placeholder="placeholderValue" @change="selectOnChange" />

  </div>
</template>
<script>
export default {
  props: ['placeholderValue'],  
  data(){
    return {
      options: [
        {
          value: 'zhejiang',
          label: 'Zhejiang',
          children: [
            {
              value: 'hangzhou',
              label: 'Hangzhou',
              children: [
                {
                  value: 'xihu',
                  label: 'West Lake',
                },
              ],
            },
          ],
        },
        {
          value: 'jiangsu',
          label: 'Jiangsu',
          children: [
            {
              value: 'nanjing',
              label: 'Nanjing',
              children: [
                {
                  value: 'zhonghuamen',
                  label: 'Zhong Hua Men',
                },
              ],
            },
          ],
        },
      ],
    }
  },
  methods: {
    selectOnChange(){},
    
  },
}
</script>
<style lang="scss" scoped>

</style>
